<template>
  <b-card>
    <nx-bform class="login-form" @submit="login">
      <h5>{{ $t("title") }}</h5>

      <nx-bform-server-errors />

      <b-form-group
        label-class="cps-label"
        id="cps-participants"
        :label="$t('cps-label')"
        label-for="cps-participants"
      >
        <b-form-select
          id="cps-participants"
          v-model="identity.ldapProfileID"
          :options="cpsList"
          value-field="ldapProfileID"
          text-field="desc"
        ></b-form-select>
      </b-form-group>

      <LoginNameFormGroup v-model="identity.username" required />

      <LoginPasswordFormGroup v-model="identity.password" required />
      <div class="login-form__query">
        <router-link :to="{ name: 'LoginForgetCPSPassword' }">
          {{ $t("query.forgetPassword") }}
        </router-link>
        <div @click="openOwnerAssistantModal" style="cursor: pointer">
          {{ $t("query.activeByInvitationCode") }}
        </div>
      </div>
      <b-button type="submit" variant="primary">{{ $t("login") }}</b-button>
    </nx-bform>
    <b-modal
      class="modelStyle"
      size="sm"
      id="activate-owner-assistant-modal"
      centered
      hide-footer
    >
      <div class="d-flex registration-professional-activate">
        <div class="login">
          <div class="info-btn" style="padding-left: 8px">
            <b-button
              style="width: 255px"
              @click="ownerAssistantEcertActivate"
              >{{ $t("activate") }}</b-button
            >
          </div>

          <div class="info-btn" style="padding-left: 8px">
            <b-button style="width: 255px" @click="setupInitialPwdCode">{{
              $t("setupInitialPwd")
            }}</b-button>
          </div>
        </div>
      </div>
    </b-modal>
  </b-card>
</template>

<script>
import { UserApi } from "nx-libs";
import LoginPasswordFormGroup from "@/forms/login/LoginPasswordFormGroup";
import LoginNameFormGroup from "@/forms/login/LoginNameFormGroup";
import LoginRoleFormGroup from "@/forms/login/LoginRoleFormGroup";
import { IAMSmartLoginPlainButton } from "@nextore/iam-smart";
import { SystemSettingApi } from "@/api";

export default {
  components: {
    LoginPasswordFormGroup,
    LoginNameFormGroup,
    LoginRoleFormGroup,
    IAMSmartLoginPlainButton,
  },
  data() {
    return {
      identity: {
        username: "",
        password: "",
        ldapProfileID: "",
      },
      cpsList: [
        {
          "cpsCode": "AMO",
          "desc": "Antiquities and Monuments Office",
          "ldapProfileID": 23
        },
        {
          "cpsCode": "ASD",
          "desc": "Architectural Services Department",
          "ldapProfileID": 24
        },
        {
          "cpsCode": "CEDD",
          "desc": "Civil Engineering and Development Department",
          "ldapProfileID": 25
        },
        {
          "cpsCode": "GEO",
          "desc": "Geotechnical Engineering Office",
          "ldapProfileID": 26
        },
        {
          "cpsCode": "DSD",
          "desc": "Drainage Services Department",
          "ldapProfileID": 27
        },
        {
          "cpsCode": "EPD",
          "desc": "Environmental Protection Department",
          "ldapProfileID": 28
        },
        {
          "cpsCode": "HyD",
          "desc": "Highways Department",
          "ldapProfileID": 29,
        },
        {
          "cpsCode": "HKPF",
          "desc": "Hong Kong Police Force",
          "ldapProfileID": 30
        },
        {
          "cpsCode": "HKT",
          "desc": "Hong Kong Tramways",
          "ldapProfileID": 31
        },
        {
          "cpsCode": "LandsD",
          "desc": "Lands Department",
          "ldapProfileID": 32
        },
        {
          "cpsCode": "MTRCL",
          "desc": "MTR Corporation Limited",
          "ldapProfileID": 33
        },
        {
          "cpsCode": "TPT",
          "desc": "The Peak Tram",
          "ldapProfileID": 34
        },
        {
          "cpsCode": "TD",
          "desc": "Transport Department",
          "ldapProfileID": 35
        },
        {
          "cpsCode": "WSD",
          "desc": "Water Supplies Department",
          "ldapProfileID": 36
        },
        {
          "cpsCode": "LCSD",
          "desc": "Leisure and Cultural Services Department",
          "ldapProfileID": 37
        },
        {
          "cpsCode": "FSD",
          "desc": "Fire Services Department",
          "ldapProfileID": 38
        },
        {
          "cpsCode": "EMSD",
          "desc": "Electrical and Mechanical Services Department",
          "ldapProfileID": 39
        },
        {
          "cpsCode": "AFCD",
          "desc": "Agriculture, Fisheries and Conservation Department",
          "ldapProfileID": 40
        },
       {
      "cpsCode": "LD",
      "desc": "Labour Department",
      "ldapProfileID": 41
      },
      {
      "cpsCode": "PlanD",
      "desc": "Planning Department",
      "ldapProfileID": 42
      },
      {
      "cpsCode": "DH",
      "desc": "Department of Health",
      "ldapProfileID": 43
      },
      {
      "cpsCode": "RVD",
      "desc": "Rating and Valuation Department",
      "ldapProfileID": 44
      },
      {
      "cpsCode": "MD",
      "desc": "Marine Department",
      "ldapProfileID": 45
      },
      {
      "cpsCode": "CAD",
      "desc": "Civil Aviation Department",
      "ldapProfileID": 46
      },
      {
      "cpsCode": "HAD",
      "desc": "Home Affairs Department (including the Office of Licensing Authority)",
      "ldapProfileID": 47
      },
      {
      "cpsCode": "HD",
      "desc": "Housing D",
      "ldapProfileID": 48
      },
      {
      "cpsCode": "SWD",
      "desc": "Social Welfare Department",
      "ldapProfileID": 49
      },
      {
      "cpsCode": "HKPost",
      "desc": "HK Post",
      "ldapProfileID": 50
      },
      {
      "cpsCode": "OFCA",
      "desc": "Office of the Communications Authority (OFCA)",
      "ldapProfileID": 51
      },
      {
      "cpsCode": "HKO",
      "desc": "Hong Kong Observatory",
      "ldapProfileID": 52
      },
      {
      "cpsCode": "EDB",
      "desc": "Education Bureau",
      "ldapProfileID": 53
      },
      {
      "cpsCode": "FEHD",
      "desc": "Food and Environmental Hygiene Department (FEHD)",
      "ldapProfileID": 54
      },
      {
      "cpsCode": "HA",
      "desc": "Hospital Authority",
      "ldapProfileID": 55
      },
      {
      "cpsCode": "NP360",
      "desc": "Ngong Ping 360 Limited",
      "ldapProfileID": 56
      },
      {
      "cpsCode": "AAHK",
      "desc": "Airport Authority",
      "ldapProfileID": 57
      }
                      
      ]
    };
  },
  async created() {
    const { data: publicSetting } =
      await SystemSettingApi.getCPSParticipantsSwitchIDSystemSetting();
    // console.log("publicSetting", publicSetting.CPSParticipantsSwitch);
    if (publicSetting.CPSParticipantsSwitch == true) {
      this.cpsList = [
        {
          cpsCode: "MTRCL",
          desc: "MTR Corporation Limited",
          ldapProfileID: 33,
        },
        {
          cpsCode: "HA",
          desc: "Hospital Authority",
          ldapProfileID: 55,
        },
        {
          cpsCode: "NP360",
          desc: "Ngong Ping 360 Limited",
          ldapProfileID: 56,
        },
        {
          cpsCode: "AAHK",
          desc: "Airport Authority",
          ldapProfileID: 57,
        }
        
        
        
      ];
    }
  },
  methods: {
    async login() {
      const { username, password, ldapProfileID } = this.identity;
      await UserApi.login(
        ldapProfileID,
        {
          Username: username,
          Password: password,
        },
        false
      );

      window.location.href = process.env.VUE_APP_CPS_URL;
      console.log(process.env.VUE_APP_CPS_URL);
    },
    openOwnerAssistantModal() {
      //this.$bvModal.show("activate-owner-assistant-modal");
      this.ownerAssistantEcertActivate();
    },
    ownerAssistantEcertActivate() {
      this.$router.push({
        name: "LoginCPSInvitationView",
        params: {
          ecert: true,
        },
      });
    },
    setupInitialPwdCode() {
      this.$router.push({
        name: "LoginActivationKeyView",
      });
    },
    async iamSmartLogin() {
      let lang;
      var result;
      switch (this.$i18n.locale) {
        case "zh_hk":
          lang = "zh-HK";
          result = await IAmSmartQrCodeApi.getQrCodeUrlHk();
          break;
        case "zh_cn":
          lang = "zh-CN";
          result = await IAmSmartQrCodeApi.getQrCodeUrlCn();
          break;
        default:
          lang = "en-US";
          result = await IAmSmartQrCodeApi.getQrCodeUrlUs();
      }

      const url = new Url(result.data.url, true);
      url.set("query", {
        ...url.query,
        lang,
      });
      return url.toString();
    },
    async getQrCode() {
      console.log("this.invitationCode", this.invitationCode);
      let lang = this.$i18n.locale;
      const res = await IAmSmartQrCodeApi.getQrCodeForInvite(lang);
      window.location.assign(res.data.url);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .cps-label {
  padding-bottom: 0.4rem;
}

.registration-professional-activate {
  padding: 50px 0;
  justify-content: space-around;
  .register {
    width: 200px;
    height: 150px;
    color: #fff;
    line-height: 150px;
    /*padding-top: 50px;*/
    text-align: center;
    display: table-cell;
    /*font-weight: 800;*/
    background-color: #005e97;
    border-radius: 0.25rem;
    cursor: pointer;
  }
  .login .btn_text {
    /*width: 200px !important;*/
    /*font-weight: 800 !important;*/
    /*white-space: normal !important;*/
  }
  .login .btn_text span {
    white-space: normal !important;
  }
}
.info-btn {
  margin-bottom: 30px;
}
.info-btn button {
  color: #fff;
  padding: 8px;
  border-radius: 0.25rem;
  background-color: #005d99;
  border: 1px;
  font-weight: 400 !important;
}
.modelStyle .bg-secondary {
  background-color: #005d99 !important;
}
</style>

<i18n src="@/locales/login.locale"></i18n>

<i18n src="@/locales/esh.locale"></i18n>

<i18n>
{
  "en": {
    "cps-label": "CPS Participants",
    "title": "Login CPS",
    "query": {
      "forgetPassword": "Forget @.lower:password?",
      "forgetLoginName": "Forget @.lower:loginName?",
      "registerPublicUser": "Register a @.lower:users.publicUser account?",
      "activateProfessional": "Activate a registered @.lower:users.professional or @.lower:users.contractor account?",
      "activeByInvitationCode": "Register an account by invitation code / set initial password"
    }
  },
  "zh_hk": {
    "cps-label": "CPS 參與者",
    "title": "登入 CPS",
    "query": {
      "forgetPassword": "忘記@:password?",
      "forgetLoginName": "忘記@:loginName?",
      "registerPublicUser": "註冊一個@:users.publicUser帳戶?",
      "activateProfessional": "啟用一個已註冊@:users.professional或@:users.contractor帳戶?",
      "activeByInvitationCode": "使用邀請碼註冊帳戶/設定初始密碼"
    }
  },
  "zh_cn": {
    "cps-label": "CPS 参与者",
    "title": "登入 CPS",
    "query": {
      "forgetPassword": "忘记@:password?",
      "forgetLoginName": "忘记@:loginName?",
      "registerPublicUser": "注册一个@:users.publicUser 帐户?",
      "activateProfessional": "启用一個已註冊@:users.professional或@:users.contractor帳戶?",
      "activeByInvitationCode": "使用邀请码注册帐户/设定初始密码"
    }
  }
}
</i18n>
